import React from "react";
import { ComponentQueryLoader } from "../../../../../shared/component-query-loader";
import {
  CasesIdentityVerificationHeaderDetailContainerArchivedIdentityVerificationCaseSummaryDocument,
  CasesIdentityVerificationHeaderDetailContainerArchivedIdentityVerificationCaseSummaryFieldsFragment,
} from "../../../../../../generated";
import { useQuery } from "@apollo/client";
import { HeaderDetail } from "./header-detail";

interface HeaderDetailContainerProps {
  caseId: string;
}

export const HeaderDetailContainer: React.FC<
  HeaderDetailContainerProps
> = (props) => {
  const {
    data: archivedApplicantDetailData,
    loading: archivedApplicantDetailLoading,
    error: archivedApplicantDetailError,
  } = useQuery(
    CasesIdentityVerificationHeaderDetailContainerArchivedIdentityVerificationCaseSummaryDocument,
    {
      variables: {
        archivedIdentityVerificationCaseSummaryId: props?.caseId,
      },
    }
  );

  return (
    <ComponentQueryLoader
      loading={archivedApplicantDetailLoading}
      hasData={archivedApplicantDetailData}
      error={archivedApplicantDetailError}
      hasDataComponent={
        <HeaderDetail
          data={
            archivedApplicantDetailData?.archivedIdentityVerificationCaseSummary as CasesIdentityVerificationHeaderDetailContainerArchivedIdentityVerificationCaseSummaryFieldsFragment
          }
        />
      }
    />
  );
};
